export const baseUrl =
  process.env.NODE_ENV !== 'development'
    ? '/cnjauto/'
    : 'http://localhost:8885/cnjauto/';

export const baseFileUrl =
  process.env.NODE_ENV !== 'development'
    ? '/cnjauto/fileUpload/accessFile/'
    : 'http://localhost:8885/cnjauto/fileUpload/accessFile/';

export const sysDefaultFileUrl =
  process.env.NODE_ENV !== 'development'
    ? '/cnjauto/sys/common/static/'
    : 'http://localhost:8885/cnjauto/sys/common/static/';

export const dollarCode = '00000000000E';
